import React from 'react';
import Input from '~/components/pages/MyAccount/share/Input';

import css from '../index.css';

const ContactInfo = (props) => (
  <form className={css.formWrap}>
    < Input
      mods = {['floatLef', 'half']}
      title = 'Contact Id'
      label = 'contactId'
      type = 'notNeed'
      defaultValue = {
        props.createAccountInfo.contactId
      }
      fnChange = {
        props.handleBlur
      }
      fnBlur = {
        props.handleBlur
      }
      error = {
        props.errorControl.contactId ? props.errorControl.contactId.error : ''
      }
    />
    < Input
      mods = {
        ['floatRigt', 'half']
      }
      title = 'Sales Code'
      label = 'salesCode'
      type = 'notNeed'
      defaultValue = {
        props.createAccountInfo.salesCode
      }
      fnChange = {
        props.handleBlur
      }
      fnBlur = {
        props.handleBlur
      }
      error = {
        props.errorControl.salesCode ? props.errorControl.salesCode.error : ''
      }
    />
    < Input
      mods = {
        ['floatLef', 'half']
      }
      title = 'First Name'
      label = 'firstName'
      type = 'text'
      defaultValue = {
        props.createAccountInfo.firstName
      }
      fnChange = {
        props.handleChange
      }
      fnBlur = {
        props.handleBlur
      }
      error = {
        props.errorControl.firstName ? props.errorControl.firstName.error : ''
      }
    />
    < Input
      mods = {
        ['floatRigt', 'half']
      }
      title = 'Last Name'
      label = 'lastName'
      type = 'text'
      defaultValue = {
        props.createAccountInfo.lastName
      }
      fnChange = {
        props.handleChange
      }
      fnBlur = {
        props.handleBlur
      }
      error = {
        props.errorControl.lastName ? props.errorControl.lastName.error : ''
      }
    />
    < Input
      mods = {
        ['floatLef', 'half']
      }
      title = 'Email'
      label = 'email'
      type = 'email'
      defaultValue = {
        props.createAccountInfo.email
      }
      fnChange = {
        props.handleChange
      }
      fnBlur = {
        props.handleBlurEmail
      }
      error = {
        props.errorControl.email ? props.errorControl.email.error : ''
      }
    />
    < Input
      mods = {
        ['floatRigt', 'half']
      }
      title = 'Phone'
      label = 'phone'
      type = 'phone'
      defaultValue = {
        props.createAccountInfo.phone
      }
      fnChange = {
        props.handleChange
      }
      fnBlur = {
        props.handleBlur
      }
      error = {
        props.errorControl.phone ? props.errorControl.phone.error : ''
      }
    />
  </form>
);

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/ContactInfo/index.js